import { render, staticRenderFns } from "./PackageTypes.vue?vue&type=template&id=2a5e3bc0&scoped=true"
import script from "./PackageTypes.vue?vue&type=script&lang=js"
export * from "./PackageTypes.vue?vue&type=script&lang=js"
import style0 from "./PackageTypes.vue?vue&type=style&index=0&id=2a5e3bc0&prod&scoped=true&lang=css"
import style1 from "./PackageTypes.vue?vue&type=style&index=1&id=2a5e3bc0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a5e3bc0",
  null
  
)

export default component.exports